<template>
    <div class="flex">
        <a href="#" title="Tasks" class="text-base p-4 flex hover:text-yellow-200 text-white"
           @click.prevent="open()">
            <i class="fas fa-check-square"></i>
        </a>
        <span v-if="incompleteTasks.length > 0"
              class="absolute ml-6 items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-600 text-white">
          {{ incompleteTasks.length }}
        </span>
        <slideover title="Tasks" name="tasks" shortcut="T">

            <div v-if="tasks.length">

                <ul>
                    <li v-for="task in tasks" class="flex flex-row gap-4 mb-6">
                        <a @click.prevent="toggleComplete(task)" class="text-xl text-gray-500 hover:text-brand mt-1.5">
                            <i v-if="task.complete" class="far fa-check-square"></i>
                            <i v-else class="far fa-square"></i>
                        </a>
                        <div>
                            <h3 class="text-lg font-medium"><a :href="task._links.frontend.view"
                                                               class="text-gray-700 hover:text-gray-500">{{
                                    task.name
                                }}</a></h3>
                            <div class="text-sm text-uppercase text-gray-500" v-if="task.has_package">

                                <template v-if="task._links.related">
                                    <a :href="task._links.related" class="text-brand hover:text-brand-light"><strong>{{
                                            task.package.project
                                        }}: </strong>{{
                                            task.package.name
                                        }}</a>
                                </template>
                                <template v-else>
                                    <strong>{{ task.package.project }}: </strong>{{ task.package.name }}
                                </template>
                            </div>
                            <div class="mt-1 text-xs text-gray-900"
                                 :class="{ 'text-red-500':task.past_due, 'text-gray-500':!task.past_due }">
                                <strong>Due:</strong> {{ task.due }}
                            </div>
                        </div>
                    </li>
                </ul>

            </div>
            <div v-else>
                <!-- This example requires Tailwind CSS v2.0+ -->
                <a :href="tasksUrl" type="button"
                   class="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand">
                    <i class="far fa-smile-beam text-4xl text-gray-400"></i>
                    <span class="mt-4 block font-medium text-lg text-gray-700">
                    You're Up To Date
                  </span>
                    <span class="mt-1 block text-sm text-gray-700">
                    Click To Log Tasks
                  </span>
                </a>
            </div>

        </slideover>
    </div>
</template>

<script>
import {Task} from '@models'

export default {
    props: {},
    data() {
        return {
            tasks: [],
            show: false,
            disabledOpening: false,
            hidden: true,
        }
    },
    computed: {
        tasksUrl() {
            return route('mobile.tasks')
        },
        incompleteTasks() {
            return _.filter(this.tasks, function (task) {
                return !task.complete
            })
        }
    },
    methods: {
        async toggleComplete(task) {
            if (task.complete) {
                await task.reopen();
            } else {
                await task.resolve();
            }
        },
        close() {
            eventBus.$emit('slideover-close-tasks');
            this.hidden = true;
        },
        open() {
            window.Bus.emit('close-all-slideovers');
            eventBus.$emit('slideover-open-tasks');
            this.hidden = false;
        },
        async fetch() {
            this.tasks = await Task.incomplete();
        }
    },
    mounted() {
        this.fetch();

        window.Bus.on('close-all-slideovers', () => {
            this.close()
        })

        window.Bus.on('show-package-filesystem', () => {
            this.close()
            this.disabledOpening = true;
        });

        window.Bus.on('close-package-filesystem', () => {
            this.disabledOpening = false;
        });

        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                this.close()
                return
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if (!this.disabledOpening) {
                if ((e.key === 't') || (e.key === 'T')) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hidden) {
                        this.open()
                    } else {
                        this.close()
                    }
                }
            }
        })
    }
}
</script>
